import React from 'react';
import { useTranslation } from 'localization';
import { ScopeMode } from 'types/channel';
import { LocalizedString } from 'types/context';
import { getLocalizedText } from '../../../utils/getLocalizedText';
import './ChannelSubscriptionCardMolecule.scss';

export interface ChannelSubscriptionCardMoleculeProps {
  subscription: {
    id: string;
    channel: { id: string; name: LocalizedString; description?: LocalizedString };
    scope_mode?: ScopeMode;
  };
  isInherited: boolean;
  sourceSphereName?: string;
  onUnsubscribe?: (subscriptionId: string) => void;
  onScopeChange?: (subscriptionId: string, scopeMode: ScopeMode) => void;
}

const ChannelSubscriptionCardMolecule: React.FC<ChannelSubscriptionCardMoleculeProps> = ({
  subscription,
  isInherited,
  sourceSphereName,
  onUnsubscribe,
  onScopeChange,
}) => {
  const { t } = useTranslation();

  const handleScopeToggle = () => {
    if (!onScopeChange || !subscription.scope_mode) return;
    const newScope: ScopeMode = subscription.scope_mode === 'direct' ? 'recursive' : 'direct';
    onScopeChange(subscription.id, newScope);
  };

  return (
    <div className="marketplace-channel-subscription-card-molecule">
      <div className="marketplace-channel-subscription-card-molecule__main">
        <div className="marketplace-channel-subscription-card-molecule__info">
          <div className="marketplace-channel-subscription-card-molecule__header">
            <i className="pi pi-megaphone" />
            <span className="marketplace-channel-subscription-card-molecule__name">
              {getLocalizedText(subscription.channel.name)}
            </span>
            {isInherited ? (
              <span className="marketplace-channel-subscription-card-molecule__badge marketplace-channel-subscription-card-molecule__badge--inherited">
                {t('sphereChannels.card.inheritedBadge', { sphereName: sourceSphereName })}
              </span>
            ) : (
              <span className="marketplace-channel-subscription-card-molecule__badge marketplace-channel-subscription-card-molecule__badge--direct">
                {t('sphereChannels.card.directBadge')}
              </span>
            )}
          </div>

          {subscription.channel.description && getLocalizedText(subscription.channel.description) && (
            <p className="marketplace-channel-subscription-card-molecule__description">
              {getLocalizedText(subscription.channel.description)}
            </p>
          )}
        </div>

        <div className="marketplace-channel-subscription-card-molecule__actions">
          {!isInherited && subscription.scope_mode && (
            <button
              type="button"
              className={`marketplace-channel-subscription-card-molecule__scope-toggle ${
                subscription.scope_mode === 'recursive'
                  ? 'marketplace-channel-subscription-card-molecule__scope-toggle--recursive'
                  : ''
              }`}
              onClick={handleScopeToggle}
              title={t('sphereChannels.scopeMode.label')}
            >
              <i className="pi pi-sitemap" />
              <span>
                {subscription.scope_mode === 'recursive'
                  ? t('sphereChannels.scopeMode.recursive')
                  : t('sphereChannels.scopeMode.direct')}
              </span>
            </button>
          )}

          {!isInherited && onUnsubscribe && (
            <button
              type="button"
              className="marketplace-channel-subscription-card-molecule__unsubscribe"
              onClick={() => onUnsubscribe(subscription.id)}
            >
              <i className="pi pi-times" />
              <span>{t('sphereChannels.card.unsubscribe')}</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChannelSubscriptionCardMolecule;
